<script setup lang="ts">
import { computed } from 'vue'
import { Button } from 'tdesign-mobile-vue/es/button'

type AppButtonVariant = 'primary' | 'secondary' | 'text' | 'danger'
type AppButtonSize = 'small' | 'medium' | 'large'

const props = withDefaults(
  defineProps<{
    variant?: AppButtonVariant
    type?: 'button' | 'submit' | 'reset'
    disabled?: boolean
    loading?: boolean
    block?: boolean
    size?: AppButtonSize
  }>(),
  { variant: 'primary', type: 'button', disabled: false, loading: false, block: false, size: 'large' },
)

defineEmits<{ click: [event: MouseEvent] }>()

const theme = computed(() => (props.variant === 'danger' ? 'danger' : props.variant === 'primary' ? 'primary' : 'default'))
const tdesignVariant = computed(() => (props.variant === 'text' ? 'text' : props.variant === 'secondary' ? 'outline' : 'base'))
</script>

<template>
  <Button
    :aria-busy="loading ? 'true' : undefined"
    :block="block"
    class="app-button"
    :class="[`app-button--${variant}`, `app-button--${size}`]"
    :disabled="disabled || loading"
    :loading="loading"
    :size="size"
    :theme="theme"
    :type="type"
    :variant="tdesignVariant"
    @click="$emit('click', $event)"
  >
    <slot />
  </Button>
</template>
